import { Button } from 'components/Button';
import { Headline } from 'components/Headline';

import { useHeader } from './Header.hooks';
import * as S from './Header.styles';

export function Header(): React.ReactElement {
  const { logoutUser } = useHeader();

  return (
    <S.Container>
      <Headline fontFamily="LFT Zeno Condensed" scale="xl" fontWeight="bold">
        Colmar admin panel
      </Headline>

      <Button
        fontFamily="LFT Zeno Condensed"
        iconLeft="FiLogOut"
        motive="back"
        onClick={() => logoutUser()}
      >
        Logout
      </Button>
    </S.Container>
  );
}
